import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const checkAuth = useCallback(async () => {
        try {
            const backend = process.env.REACT_APP_BACKEND_URL;
            const { data } = await axios.get(`${backend}/api/auth/me`, {
                withCredentials: true,
            });
            setUser(data);
        } catch {
            setUser(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        // CRITICAL: Returning from OAuth (URL fragment has session_id=)? Skip /me;
        // AuthCallback will exchange the session_id first and set the cookie.
        if (window.location.hash?.includes("session_id=")) {
            setLoading(false);
            return;
        }
        checkAuth();
    }, [checkAuth]);

    const logout = async () => {
        try {
            const backend = process.env.REACT_APP_BACKEND_URL;
            await axios.post(
                `${backend}/api/auth/logout`,
                {},
                { withCredentials: true }
            );
        } catch {
            /* ignore */
        }
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, setUser, loading, logout, refresh: checkAuth }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth must be used within AuthProvider");
    return ctx;
};
